// extracted by mini-css-extract-plugin
export var alert = "WhatWeDo-module--alert--b5252";
export var desktopWrapper = "WhatWeDo-module--desktopWrapper--d3849";
export var fadeInAnimation = "WhatWeDo-module--fadeInAnimation--957c7";
export var mobileWrapper = "WhatWeDo-module--mobileWrapper--a21fd";
export var title = "WhatWeDo-module--title--2f4e7";
export var wrapper = "WhatWeDo-module--wrapper--79a0d";